import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Routes from './routes';

import 'bootstrap/dist/css/bootstrap.min.css';
import GlobalStyle from './styles/global';

import Header from './components/Header';
import Info from './components/Info';
import Footer from './components/Footer';
import Certificate from './components/Certificate';

import AppProvider from './hooks';

const App: React.FC = () => (
  <>
    <AppProvider>
      <BrowserRouter basename="/publicidade-legal">
        <div className="container">
          <Header />
          <div className="p-3 p-sm-4 p-xl-5">
            <Routes />
          </div>
          <Certificate />
          <Info />
        </div>
        <Footer />
      </BrowserRouter>
    </AppProvider>
    <GlobalStyle />
  </>
);

export default App;
